// squarePhoto cuts a picture to its middle square and makes it small, so a
// profile photo is a few kilobytes whatever was chosen.
import type { Session } from "./session";

// setPhoto makes a picture one's profile photo, squared and made small.
export async function setPhoto(session: Session, file: Blob) {
  const photo = await squarePhoto(file);
  await session.setOwn(async () => ({ principal: await session.api.setAvatar(photo) }));
}

export async function squarePhoto(file: Blob, side = 256): Promise<Blob> {
  const bitmap = await createImageBitmap(file);
  const s = Math.min(bitmap.width, bitmap.height);
  const canvas = document.createElement("canvas");
  canvas.width = canvas.height = side;
  const g = canvas.getContext("2d");
  if (!g) throw new Error("no canvas");
  g.drawImage(bitmap, (bitmap.width - s) / 2, (bitmap.height - s) / 2, s, s, 0, 0, side, side);
  bitmap.close();
  const out = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/png"));
  if (!out) throw new Error("the picture could not be made smaller");
  return out;
}
